/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnauthorizedRouteImport } from './routes/unauthorized'
import { Route as StatusRouteImport } from './routes/status'
import { Route as InlineDemoRouteImport } from './routes/inline-demo'
import { Route as ShellRouteImport } from './routes/_shell'
import { Route as ShellIndexRouteImport } from './routes/_shell/index'
import { Route as ShellUsersRouteImport } from './routes/_shell/users'
import { Route as ShellRolesRouteImport } from './routes/_shell/roles'
import { Route as ShellRedirectsRouteImport } from './routes/_shell/redirects'
import { Route as ShellLegalRouteImport } from './routes/_shell/legal'
import { Route as ShellIntegrationRouteImport } from './routes/_shell/integration'
import { Route as ShellAuditRouteImport } from './routes/_shell/audit'
import { Route as ShellAppsRouteImport } from './routes/_shell/apps'

const UnauthorizedRoute = UnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => rootRouteImport,
} as any)
const StatusRoute = StatusRouteImport.update({
  id: '/status',
  path: '/status',
  getParentRoute: () => rootRouteImport,
} as any)
const InlineDemoRoute = InlineDemoRouteImport.update({
  id: '/inline-demo',
  path: '/inline-demo',
  getParentRoute: () => rootRouteImport,
} as any)
const ShellRoute = ShellRouteImport.update({
  id: '/_shell',
  getParentRoute: () => rootRouteImport,
} as any)
const ShellIndexRoute = ShellIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellUsersRoute = ShellUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => ShellRoute,
} as any)
const ShellRolesRoute = ShellRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => ShellRoute,
} as any)
const ShellRedirectsRoute = ShellRedirectsRouteImport.update({
  id: '/redirects',
  path: '/redirects',
  getParentRoute: () => ShellRoute,
} as any)
const ShellLegalRoute = ShellLegalRouteImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => ShellRoute,
} as any)
const ShellIntegrationRoute = ShellIntegrationRouteImport.update({
  id: '/integration',
  path: '/integration',
  getParentRoute: () => ShellRoute,
} as any)
const ShellAuditRoute = ShellAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => ShellRoute,
} as any)
const ShellAppsRoute = ShellAppsRouteImport.update({
  id: '/apps',
  path: '/apps',
  getParentRoute: () => ShellRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof ShellIndexRoute
  '/inline-demo': typeof InlineDemoRoute
  '/status': typeof StatusRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/apps': typeof ShellAppsRoute
  '/audit': typeof ShellAuditRoute
  '/integration': typeof ShellIntegrationRoute
  '/legal': typeof ShellLegalRoute
  '/redirects': typeof ShellRedirectsRoute
  '/roles': typeof ShellRolesRoute
  '/users': typeof ShellUsersRoute
}
export interface FileRoutesByTo {
  '/inline-demo': typeof InlineDemoRoute
  '/status': typeof StatusRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/apps': typeof ShellAppsRoute
  '/audit': typeof ShellAuditRoute
  '/integration': typeof ShellIntegrationRoute
  '/legal': typeof ShellLegalRoute
  '/redirects': typeof ShellRedirectsRoute
  '/roles': typeof ShellRolesRoute
  '/users': typeof ShellUsersRoute
  '/': typeof ShellIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_shell': typeof ShellRouteWithChildren
  '/inline-demo': typeof InlineDemoRoute
  '/status': typeof StatusRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/_shell/apps': typeof ShellAppsRoute
  '/_shell/audit': typeof ShellAuditRoute
  '/_shell/integration': typeof ShellIntegrationRoute
  '/_shell/legal': typeof ShellLegalRoute
  '/_shell/redirects': typeof ShellRedirectsRoute
  '/_shell/roles': typeof ShellRolesRoute
  '/_shell/users': typeof ShellUsersRoute
  '/_shell/': typeof ShellIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/inline-demo'
    | '/status'
    | '/unauthorized'
    | '/apps'
    | '/audit'
    | '/integration'
    | '/legal'
    | '/redirects'
    | '/roles'
    | '/users'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/inline-demo'
    | '/status'
    | '/unauthorized'
    | '/apps'
    | '/audit'
    | '/integration'
    | '/legal'
    | '/redirects'
    | '/roles'
    | '/users'
    | '/'
  id:
    | '__root__'
    | '/_shell'
    | '/inline-demo'
    | '/status'
    | '/unauthorized'
    | '/_shell/apps'
    | '/_shell/audit'
    | '/_shell/integration'
    | '/_shell/legal'
    | '/_shell/redirects'
    | '/_shell/roles'
    | '/_shell/users'
    | '/_shell/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ShellRoute: typeof ShellRouteWithChildren
  InlineDemoRoute: typeof InlineDemoRoute
  StatusRoute: typeof StatusRoute
  UnauthorizedRoute: typeof UnauthorizedRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/unauthorized': {
      id: '/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof UnauthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/status': {
      id: '/status'
      path: '/status'
      fullPath: '/status'
      preLoaderRoute: typeof StatusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inline-demo': {
      id: '/inline-demo'
      path: '/inline-demo'
      fullPath: '/inline-demo'
      preLoaderRoute: typeof InlineDemoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_shell': {
      id: '/_shell'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ShellRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_shell/': {
      id: '/_shell/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ShellIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/users': {
      id: '/_shell/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof ShellUsersRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/roles': {
      id: '/_shell/roles'
      path: '/roles'
      fullPath: '/roles'
      preLoaderRoute: typeof ShellRolesRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/redirects': {
      id: '/_shell/redirects'
      path: '/redirects'
      fullPath: '/redirects'
      preLoaderRoute: typeof ShellRedirectsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/legal': {
      id: '/_shell/legal'
      path: '/legal'
      fullPath: '/legal'
      preLoaderRoute: typeof ShellLegalRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/integration': {
      id: '/_shell/integration'
      path: '/integration'
      fullPath: '/integration'
      preLoaderRoute: typeof ShellIntegrationRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/audit': {
      id: '/_shell/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof ShellAuditRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/apps': {
      id: '/_shell/apps'
      path: '/apps'
      fullPath: '/apps'
      preLoaderRoute: typeof ShellAppsRouteImport
      parentRoute: typeof ShellRoute
    }
  }
}

interface ShellRouteChildren {
  ShellAppsRoute: typeof ShellAppsRoute
  ShellAuditRoute: typeof ShellAuditRoute
  ShellIntegrationRoute: typeof ShellIntegrationRoute
  ShellLegalRoute: typeof ShellLegalRoute
  ShellRedirectsRoute: typeof ShellRedirectsRoute
  ShellRolesRoute: typeof ShellRolesRoute
  ShellUsersRoute: typeof ShellUsersRoute
  ShellIndexRoute: typeof ShellIndexRoute
}

const ShellRouteChildren: ShellRouteChildren = {
  ShellAppsRoute: ShellAppsRoute,
  ShellAuditRoute: ShellAuditRoute,
  ShellIntegrationRoute: ShellIntegrationRoute,
  ShellLegalRoute: ShellLegalRoute,
  ShellRedirectsRoute: ShellRedirectsRoute,
  ShellRolesRoute: ShellRolesRoute,
  ShellUsersRoute: ShellUsersRoute,
  ShellIndexRoute: ShellIndexRoute,
}

const ShellRouteWithChildren = ShellRoute._addFileChildren(ShellRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  ShellRoute: ShellRouteWithChildren,
  InlineDemoRoute: InlineDemoRoute,
  StatusRoute: StatusRoute,
  UnauthorizedRoute: UnauthorizedRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
